import React from 'react';
import Button from '@material-ui/core/Button';
import classes from './save-button.module.css';

const SaveButton = ({ 
	saveOnClick, 
	disabled = false 
}) => {

	if (disabled) {
		return (
			<Button className={`${classes[`save-button`]} ${classes['disabled']}`} variant="outlined">
				Save
			</Button>
		);
	}
	
	return (
			<Button className={classes['save-button']} variant="outlined" onClick={saveOnClick}>
				Save
			</Button>
	);
};

export default SaveButton;
